export default __webpack_public_path__ + "1945b7eeea37a098e970938580d63d4c.svg";